import { createSlice } from '@reduxjs/toolkit';
import { v4 as uniqueID } from 'uuid';

function makeComment(text) {
  return {
    id: uniqueID(),
    text,
    time: Date.now(),
  };
}

export const notesSettingsSlice = createSlice({
  name: 'notesSettings',
  initialState: {
    isActive: true,
    activeEntityId: null,
    entities: [],
    commentData: [],
  },
  reducers: {
    toggleNoteMode: (state) => {
      const { isActive } = state;
      state.isActive = !isActive;
    },
    setActiveEntityId: (state, action) => {
      const { payload } = action;
      console.log('changes note id to ' + payload);
      state.activeEntityId = payload;
    },
    resetActiveEntityId: (state) => {
      state.activeEntityId = null;
    },

    addNote: (state, action) => {
      const { coords, targetSelector, text, noteId, isSubNote } = action.payload;

      const id = noteId;
      state.entities.push({
        id,
        coords,
        targetSelector,
        comments: [makeComment(text)],
      });
      // if (!isSubNote) {
      //   state.activeEntityId = id;
      // }
    },

    addCommentData: (state, action) => {
      console.log('Adding comment data:', action);
      const { payload } = action;
      state.commentData = payload;
    },

    clearNotes: (state) => {
      state.entities = [];
      state.activeEntityId = null;
    },

    deleteNote: (state, action) => {
      const { entities } = state;
      const { payload } = action;

      state.entities = entities.filter((note) => note.id !== payload);
    },

    addComment: (state, action) => {
      const { payload } = action;
      const selectedNote = state.entities.find((note) => note.id === payload.id);

      selectedNote.comments.push(makeComment(payload.text));
    },

    updateComment: (state, action) => {
      const { payload } = action;
      const { entities } = state;

      for (const note of entities) {
        const selectedComment = note.comments.find((comment) => comment.id === payload.id);

        if (selectedComment) {
          selectedComment.text = payload.text;
          break;
        }
      }
    },
  },
});

export const {
  toggleNoteMode,
  setActiveEntityId,
  resetActiveEntityId,
  addNote,
  deleteNote,
  addComment,
  updateComment,
  clearNotes,
  addCommentData,
} = notesSettingsSlice.actions;

export const selectActiveEntityId = (state) => state.notesSettings.activeEntityId;
export const selectNotes = (state) => state.notesSettings.entities;
export const selectIsNotMode = (state) => state.notesSettings.isActive;
export const selectCommentData = (state) => state.notesSettings.commentData;

export default notesSettingsSlice.reducer;
